import '../css/app.css';
import $ from 'jquery';

window.$ = $;
window.jQuery = $;


$(document).ready(function($) {

  initMenuToggler();
  initImpactFilter();
  initBackgroundHover();
  initSearchForm();
  initStickyMenu();

});


function initMenuToggler() {

  $('#menu-toggle').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $('#navigation').toggleClass('is-visible');
    $('html, body').toggleClass('noscroll');
  });

}


function initImpactFilter() {

  $('select#filter-impact').change(function() {
    var filter = $(this).val();
    filterGrid(filter);
  });

}

function filterGrid(value) {

  var list = $(".impact-grid .impact-square");
  $(list).fadeOut("fast");
  if(value == "all") {
    $(".impact-grid").find("article").each(function(i) {
      $(this).delay(200).fadeIn("fast");
    });
  } else {
    $(".impact-grid").find("article[data-sector=" + value + "]").each(function(i) {
      $(this).delay(200).fadeIn("fast");
    });
  }

}


function initBackgroundHover() {

  //Home page
  var underline = $(".hero--home .nlt-underline");
  var background = $("header.home-header");

  // All other pages
  if (underline.length == 0) {
    underline = $(".hero--title");
    background = $(".hero-section .hero");
  }

  if(background.length) {

    var originalBG = background.css("background");
    var tintedBG = originalBG.replace("rgba(13, 24, 52, 0.7), rgba(13, 24, 52, 0.7)", "rgba(13, 24, 52, 0.6), rgba(13, 24, 52, 0.6)");

    underline.on("mouseenter", function() {
      background.css("background",tintedBG);
    });

    underline.on("mouseleave", function () {
      background.css("background", originalBG);
    })

  }

}


function initSearchForm() {

  var isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i) != null;
  var touchOrClick = (isMobile)? 'touchstart' : 'click';

  var searchContainer = $("#search-container");
  var searchField = $("#search-query");
  var searchIcon = $(".search-icon");
  var closeIcon = $(".close-btn");

  searchIcon.on(touchOrClick, function(e) {
    searchContainer.toggleClass('open-search');
    if(!searchContainer.hasClass('open-search')) {
      searchField.blur();
      e.preventDefault()
    } else {
      searchField.focus();
    }
    e.stopPropagation();
  });

  searchField.on(touchOrClick, function (e) {
    e.stopPropagation();
  });

  closeIcon.on(touchOrClick, function (e) {
    searchContainer.removeClass('open-search');
    searchField.blur();
  });

}


function initStickyMenu() {
  var searchIcon = $(".search-icon"),
    menuIcon = $("#menu-toggle"),
    headerHeight = 100,
    threshold = 0,
    lastScroll = 0;


  $(document).on('scroll', function(e) {
    if($(window).width() < 760) {
      var newScroll = $(document).scrollTop(),
        difference = newScroll - lastScroll;

      //Normalize threshold Range
      threshold = (threshold + difference > headerHeight) ? headerHeight : threshold + difference;

      threshold = (threshold < 0) ? 0 : threshold;
      searchIcon.css('top', (-threshold + 16)+'px' );
      menuIcon.css('top', (-threshold + 24)+'px' );


      lastScroll = newScroll;
    }
  });

}



// WEBPACK FOOTER //
// ./assets/js/app.js